import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Footer.module.scss';

const ForClients = ({ omitHeading = false }) => {
  return (
    <ul className={styles.linkList}>
      {!omitHeading && (
        <li>
          <a href="/hire-a-freelancer">For clients</a>
        </li>
      )}
      <li>
        <a href="/howitworks">How it works</a>
      </li>
      <li>
        <a href="/post-a-job">Post a project</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/video-and-animation">
          Hire video &amp; animation experts
        </a>
      </li>
      <li>
        <a href="/hire-a-freelancer/programming">Hire developers</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/graphic-design">Hire designers</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/music">Hire music &amp; audio experts</a>
      </li>
      <li>
        <a href="/hire-a-freelancer/digital-marketing">
          Hire marketing experts
        </a>
      </li>
      <li>
        <a href="/hire-a-freelancer">See more freelancer skills</a>
      </li>
    </ul>
  );
};

ForClients.propTypes = {
  omitHeading: PropTypes.bool,
};

export default ForClients;
